<template>
    <div class="my-info-BankCard">
        <div v-if="showList">
            <div class="warnTip">
                {{ $t("bankCardPage.tips") }}
            </div>
            <div class="myTitle2">
                <p>{{ $t("bankCardPage.addMethod") }}</p>
            </div>
            <el-row class="bankList">
                <div class="bankItem" v-for="bank in bankArr" :key="bank.id">
                    <img loading="lazy" v-lazy="$common.getImgUrl(bank.imgUrl)" />
                    <div class="itemInfo">
                        <p class="itemInfop1">{{ bank.type === 2 ? `${$t("accountPage.wallet")}(${bank.name})` : bank.name }}</p>
                        <p class="itemInfop2">{{ bank.branch }}</p>
                        <p class="itemInfop3">
                            {{ $utils.hideMiddle(bank.number) }}
                        </p>
                    </div>
                </div>
                <div v-if="bankCardList.length < bankCountNumber" class="bankItem bankItemAdd" @click="goAddBank(0)">
                    <img loading="lazy" v-lazy="require('../../../assets/images/my/info4.png')" />
                    <p>{{ $t("bankCardPage.addBank") }}</p>
                    <div>{{ $t("bankCardPage.text1") }}</div>
                </div>
                <div v-if="usdtList.length < usdtCountNumber" class="bankItem bankItemAdd" @click="goAddBank(1)">
                    <img loading="lazy" v-lazy="require('../../../assets/images/my/info4.png')" />
                    <p>{{ $t("bankCardPage.addMoney") }}</p>
                    <div>{{ $t("bankCardPage.text2") }}</div>
                </div>
                <div v-if="walletList.length < walletCountNumber" class="bankItem bankItemAdd" @click="goAddBank(2)">
                    <img loading="lazy" v-lazy="require('../../../assets/images/my/info4.png')" />
                    <p>{{ $t("bankCardPage.wallet") }}</p>
                    <div>{{ $t("bankCardPage.text2") }}</div>
                </div>
            </el-row>
        </div>
        <div class="bankAdd" v-else>
            <template v-if="typeBank == 0 || typeBank == 1">
                <div>
                    <div class="myItems">
                        <span class="item1">{{
                            $t("bankCardPage.bankName")
                        }}</span>
                        <el-select
                            v-model="bankObj.name"
                            :placeholder="$t('bankCardPage.selectBank')"
                            :disabled="isUsdtShow"
                        >
                            <el-option
                                :style="{fontWeight:item.name=='数字货币'?'bold':'500'}"
                                v-for="item in querybank"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                        <span class="item3">*</span>
                        <span class="item4" v-if="!isUsdtShow">{{
                            $t("bankCardPage.selectBank")
                        }}</span>
                    </div>
                    <div class="myItems">
                        <span class="item1">{{
                            isUsdtShow ? '链路' :
                            $t("bankCardPage.branch")
                        }}</span>
                        <el-input
                            v-model="bankObj.branch"
                            clearable
                            :placeholder="isUsdtShow ? '请输入ERC20或TRC20' : $t('bankCardPage.inputbranch')"
                        ></el-input>
                        <span class="item3">*</span>
                        <span class="item4">
                            {{ isUsdtShow ? '请输入ERC20或TRC20' : $t("bankCardPage.inputbranch") }}
                        </span>
                    </div>
                    <div class="myItems">
                        <span class="item1">
                            {{ isUsdtShow ? '真实姓名' : $t("bankCardPage.username") }}
                        </span>
                        <el-input
                            v-model="userInfo.realName"
                            :disabled="!!userInfo.realName"
                        ></el-input>
                        <span class="item3">*</span>
                        <span class="item4">{{
                            isUsdtShow ? '请输入您的真实姓名' :
                            $t("bankCardPage.inputName")
                        }}</span>
                    </div>
                    <div class="myItems">
                        <span class="item1">{{
                            isUsdtShow ? '地址' :
                            $t("bankCardPage.bankCode")
                        }}</span>
                        <el-input
                            v-model="bankObj.number"
                            maxlength="100"
                            clearable
                            :placeholder="isUsdtShow ? '请输入钱包地址' : $t('bankCardPage.inputCode')"
                        ></el-input>
                        <span class="item3">*</span>
                        <span class="item4">{{
                            isUsdtShow ? '钱包地址' : 
                            '银行卡号'
                        }}</span>
                    </div>
                    <div class="myItems">
                        <span class="item1">{{
                            isUsdtShow ? '确认地址' :
                            $t("bankCardPage.code2")
                        }}</span>
                        <el-input
                            v-model="bankNumber2"
                            maxlength="100"
                            clearable
                            :placeholder="isUsdtShow ? '请再次输入钱包地址' : $t('bankCardPage.bankcode2')"
                        ></el-input>
                        <span class="item3">*</span>
                        <span class="item4">{{
                            isUsdtShow ? '再次输入钱包地址' :
                            $t("bankCardPage.bankcode2")
                        }}</span>
                    </div>
                </div>
            </template>
            <template v-if="typeBank == 2">
                <div>
                    <div class="myItems">
                        <span class="item1">{{
                            $t("bankCardPage.pType")
                        }}</span>
                        <el-select
                            v-model="bankObj.name"
                            :placeholder="$t('bankCardPage.pType')"
                        >
                            <el-option
                                v-for="item in wallets"
                                :key="item.id"
                                :label="item.name"
                                :value="item.name"
                            ></el-option>
                        </el-select>
                        <span class="item3">*</span>
                        <span class="item4">{{
                            $t("bankCardPage.pType")
                        }}</span>
                    </div>
                    <div class="myItems">
                        <span class="item1">{{
                            $t("bankCardPage.adress")
                        }}</span>
                        <el-input
                            v-model="bankObj.number"
                            maxlength="100"
                            clearable
                            placeholder="请输入钱包地址"
                        ></el-input>
                        <span class="item3">*</span>
                        <span class="item4">钱包地址</span>
                    </div>
                </div>
            </template>
            <template>
                <div v-show="sendShow">
                    <div class="myItems">
                        <span class="item1">
                            {{ $t("bankCardPage.phone") }}
                        </span>
                        <el-input
                            v-model="phoneNum"
                            clearable
                            disabled
                            :placeholder="$t('bankCardPage.phoneInput')"
                        ></el-input>
                    </div>
                    <div class="myItems codeFlex">
                        <span class="item1">
                            {{ $t("bankCardPage.phonecode") }}
                        </span>
                        <div class="codeBox">
                            <el-input
                                v-model="bankObj.code"
                                type="number"
                                :placeholder="$t('bankCardPage.codeInput')"
                                class="codeInput"
                            >
                            </el-input>
                            <div class="btncode" @click="sendVerification">
                                {{ btnCode }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <div class="mytButton">
                <span class="btnConfirm" @click="addbank">{{
                    $t("bankCardPage.determine")
                }}</span>
                <span class="btnCancel" @click="showList = true">{{
                    $t("bankCardPage.back")
                }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            showList: true,
            querybank: [],
            bankObj: {
                name: "",
                branch: "",
                number: "",
                phone: null,
                code: "",
            },
            bankNumber2: "",
            typeBank: 0,
            wallets: [],
            walletName: "USDT",
            address: "",
            sendShow: false,
            disabledBut: false,
            btnCode: "发送验证码",
            intervalID: "",
            bankCountNumber: 0, // 可绑定的银行卡数量
            usdtCountNumber: 0, // 可绑定的数字货币数量
            walletCountNumber: 0, // 可绑定三方钱包数量
            bind_usdt_sms:0,
            bind_sms:0,
            isUsdtShow:false,//银行卡/数字货币
        };
    },
    computed: {
        ...mapGetters(["bankArr", "userInfo"]),
        phoneNum () {
            return this.userInfo.phone
        },
        bankCardList() {
            return this.bankArr.filter(item => { return item.type == 0});
        },
        usdtList() {
            return this.bankArr.filter(item => { return item.type == 1});
        },
        walletList() {
            return this.bankArr.filter(item => { return item.type == 2});
        }
    },
    created() {
        // this.getBankCountConfig();
        this.$nkhttp.http(this.$api.querybank, null, "get", (data) => {
            // this.querybank = data;
            this.querybank = data.filter(item => { return item.type === 0 })
            this.wallets = data.filter(item => { return item.type === 2 }) // 三方钱包列表
        });
        this.getBindSmsSetting();
    },
    methods: {
        //获取银行卡绑定配置、是否需要短信验证
        getBindSmsSetting() {
            this.$http.get(this.$api.getSettings, "withdraw_open").then(res => {
                if (res) {
                    this.bankCountNumber = res.data.svalue.bank_card_count; // 可绑银行卡数量
                    this.usdtCountNumber = res.data.svalue.digit_money_count; // 可绑数字货币数量
                    this.walletCountNumber = res.data.svalue.origo_money_count; // 可绑的三方钱包数量
                    this.bind_usdt_sms = res.data.svalue.bind_usdt_sms || 0;
                    this.bind_sms = res.data.svalue.bind_sms || 0;
                }
            });
        },
        // 获取短信验证码
        sendVerification() {
            if (this.disabledBut) {
                return;
            }
            if (!/^1[3456789]\d{9}$/.test(this.phoneNum)) {
                this.$message.error(this.$t("bankCardPage.phoneEorro"));
                return;
            }
            this.$http.get(this.$api.sendSmsCode + "/" + this.phoneNum + "?functionId=7").then((res) => {
                if (res.code === 0) {
                    this.$message({
                        message: this.$t("bankCardPage.getcodeSuee"),
                        type: "success",
                    });
                    this.disabledBut = !this.disabledBut;
                    this.btnCode = "60S";
                    var time = 60;
                    this.intervalID = setInterval(() => {
                        time--;
                        this.btnCode = time + "S";
                        if (time == 0) {
                            this.disabledBut = !this.disabledBut;
                            clearInterval(this.intervalID);
                            this.btnCode = "发送验证码";
                            time = 60;
                        }
                    }, 1000);
                } else {
                    this.$message({
                        message: res.msg,
                        type: "error",
                    });
                }
            });
        },
        // 获取银行卡绑定配置
        // getBankCountConfig () {
        //     this.$http.get(this.$api.getSettings, "withdraw_open").then(res => {
        //         try {
        //             this.countNumber = res.data.svalue.bank_card_count;
        //         } catch {
        //             this.countNumber = 0;
        //         }
        //     })
        // },
        goAddBank(i) {
            if (!this.userInfo.realName) {
                this.$confirm(
                    this.$t("bankCardPage.tipName"),
                    this.$t("bankCardPage.tipsTitle"),
                    {
                        confirmButtonText: this.$t("bankCardPage.determine"),
                        cancelButtonText: this.$t("bankCardPage.cancel"),
                        type: "warning",
                    }
                ).then(() => {
                    this.$router.push({ path: "/my/info/account" });
                });
            } else if (!this.userInfo.withdrawPassWordState) {
                this.$confirm(
                    this.$t("bankCardPage.tipsPawss"),
                    this.$t("bankCardPage.tipsTitle"),
                    {
                        confirmButtonText: this.$t("bankCardPage.determine"),
                        cancelButtonText: this.$t("bankCardPage.cancel"),
                        type: "warning",
                    }
                ).then(() => {
                    this.$router.push({ path: "/my/security/capital" });
                });
            } else if (this.sendShow && !this.phoneNum) {
                this.$confirm(
                    '请绑定手机号再添加银行卡',
                    this.$t("bankCardPage.tipsTitle"),
                    {
                        confirmButtonText: this.$t("bankCardPage.determine"),
                        cancelButtonText: this.$t("bankCardPage.cancel"),
                        type: "warning",
                    }
                ).then(() => {
                    this.$router.push({ path: "/my/info/account" });
                });
            } else {
                this.bankObj = {
                    name: "",
                    branch: "",
                    number: "",
                    type: 0,
                    phone: "",
                    code: "",
                };
                this.typeBank = i;
                this.showList = false;
                if (i === 1) {
                    this.bankObj.name = '数字货币';
                }
            }
        },
        addbank() {
            if (this.typeBank == 2) {
                // 三方钱包
                this.bankObj.branch = this.bankObj.name;
            }
            if (!this.bankObj.name) {
                this.$message.error(this.$t("bankCardPage.selectBank"));
                return;
            }
            if (!this.bankObj.branch && this.bankObj.name === '数字货币') {
                this.$message.error('请输入ERC20或TRC20');
                return;
            }
            if (!this.bankObj.branch) {
                this.$message.error(this.$t("bankCardPage.inputbranch"));
                return;
            }
            if (!this.bankObj.number && this.bankObj.name === '数字货币') {
                this.$message.error("请输入钱包地址");
                return;
            }
            if (!this.bankObj.number) {
                this.$message.error(this.$t("bankCardPage.inputCode"));
                return;
            }
            if (this.bankObj.number != this.bankNumber2 && this.bankObj.name === '数字货币') {
                this.$message.error("两次输入的钱包地址不一致");
                return;
            }
            if (this.typeBank === 0) {
                if (this.bankObj.number != this.bankNumber2) {
                    this.$message.error(this.$t("bankCardPage.errCode"));
                    return;
                }
            }
            if (this.sendShow) {
                if (!this.phoneNum) {
                    this.$message({
                        message: this.$t("bankCardPage.phoneInput"),
                        type: "warning",
                    });
                    return;
                }
                // if (!/^1[3456789]\d{9}$/.test(this.bankObj.phone * 1)) {
                //     this.$message.error(this.$t("bankCardPage.phoneEorro"));
                //     return;
                // }
                if (!this.bankObj.code) {
                    this.$message({
                        message: this.$t("bankCardPage.codeInput"),
                        type: "warning",
                    });
                    return;
                }
            }

            let _obj = {
                ...this.bankObj,
                ...{
                    memberId: this.userInfo.userId,
                    account: this.userInfo.realName,
                    type: this.typeBank,
                    phone: this.phoneNum, //s手机号
                    smsCode: this.bankObj.code, //验证码
                },
            };
            _obj.number = this.bankObj.number.replace(/\s*/g, ""); //去除所有空格
            this.$nkhttp.http(this.$api.addbank, _obj, "post", () => {
                this.$message.success(this.$t("bankCardPage.addRes"));
                this.$nkhttp.getBank();
                this.$nkhttp.getUserInfo();
                this.bankObj = { name: "", branch: "", number: "", type: 0 };
                this.bankNumber2 = "";
                this.showList = true;
            });
        },
        removeBank(_id) {
            this.$nkhttp.http(
                this.$api.removeBack + "/" + _id,
                null,
                "delete",
                () => {
                    this.$message.success("删除成功");
                    this.$nkhttp.getBank();
                }
            );
        },
    },
    watch: {
        // ["bankObj.number"](val) {
        //     if (val && this.bankObj.name != '数字货币') {
        //         this.bankObj.number = val
        //             .replace(/\D/g, "")
        //             .replace(/....(?!$)/g, "$& ");
        //     }
        // },
        // bankNumber2(val) {
        //     if (val && this.bankObj.name != '数字货币') {
        //         this.bankNumber2 = val
        //             .replace(/\D/g, "")
        //             .replace(/....(?!$)/g, "$& ");
        //     }
        // },
        //  判断当前存款方式
        ['bankObj.name'](){
            if(this.bankObj.name == '数字货币'){
                this.isUsdtShow = true
                this.sendShow = this.bind_usdt_sms == 1 ? true : false;
            }else{
                this.isUsdtShow = false
                this.sendShow = this.bind_sms == 1 ? true : false;
            }
            if (this.sendShow && !this.phoneNum) {
                this.$confirm(
                    '您还未绑定手机，是否去绑定手机？',
                    this.$t("bankCardPage.tipsTitle"),
                    {
                        confirmButtonText: this.$t("bankCardPage.determine"),
                        cancelButtonText: this.$t("bankCardPage.cancel"),
                        type: "warning",
                    }
                ).then(() => {
                    this.$router.push({ path: "/my/info/account" });
                });
            }
        },
    },
};
</script>

<style lang="scss" >
    @import url('../../../assets/css/common.css');
.my-info-BankCard {
    .myTitle2 {
        margin-top: 30px;
    }
    .bankList {
        .bankItem {
            float: left;
            width: 31.7%;
            position: relative;
            border: 1px solid #e6e6e6;
            border-color: #4ddbb8;
            box-shadow: 0 0 10px rgba(0, 188, 141, 0.25);
            border-radius: 8px;
            margin: 15px 0 10px 0;
            height: 150px;
            &:nth-child(3n-1),
            &:nth-child(3n-2) {
                margin-right: 2%;
            }
            img {
                width: 48px;
                height: 48px;
                float: left;
                margin: 15px;
            }
            .itemInfo {
                float: left;
                padding-bottom: 10px;
                padding-top: 3px;
                .itemInfop1 {
                    line-height: 30px;
                    font-size: 14px;
                    margin-top: 12px;
                    color: #333;
                    font-weight: 600;
                }
                .itemInfop2 {
                    line-height: 20px;
                    font-size: 12px;
                    color: #999;
                }
                .itemInfop3 {
                    line-height: 30px;
                    font-size: 16px;
                    margin-top: 6px;
                    font-weight: 500;
                    color: #444;
                }
            }
            .operation {
                float: left;
                width: 100%;
                border-top: 1px solid #e8e8e8;
                height: 36px;
                span {
                    color: #00bc8d;
                    float: right;
                    margin-right: 16px;
                    line-height: 30px;
                    cursor: pointer;
                }
            }
            .locking {
                position: absolute;
                right: 10px;
                top: 10px;
                cursor: pointer;
            }
        }
        .bankItemAdd {
            cursor: pointer;
            background: #f8f8f8;
            border: 1px dashed #aaa;
            box-shadow: 0 0 10px rgba(0, 0, 0, 0.08);
            text-align: center;
            transition: all 0.1s linear;
            img {
                margin: 12px 0 2px;
                width: 48px;
                height: 48px;
                float: none;
            }
            p {
                font-size: 14px;
                line-height: 30px;
                color: #999;
            }
            div {
                line-height: 24px;
                font-size: 13px;
                font-weight: 200;
                color: #00bc8d;
            }
            &:hover {
                margin-top: 10px;
                box-shadow: 0 0 15px rgba(0, 0, 0, 0.08);
                p {
                    color: #aaa;
                }
            }
        }
        .marginR {
            margin-right: 0px;
        }
    }
    .bankAdd {
        padding-top: 20px;
    }
    .el-input-group__append {
        background: #fff;
        color: #ff3a2b;
    }
    .codeFlex {
        display: flex;
    }
    .codeBox {
        display: flex;
        .btncode {
            color: #fff;
            background: #ff3a2b;
            border-radius: 4px;
            padding: 0 10px;
            margin-left: 10px;
            flex-shrink: 0;
            cursor: pointer;
        }
    }
    .codeInput {
        flex-grow: 2;
    }
}
.el-message-box__title {
    font-size: 16px;
    width: 95%;
}
</style>